import { extend } from "vee-validate";
import {
  required,
  email,
  alpha_num,
  min_value,
  max_value,
  min,
  max,
  length,
  integer,
  regex,
  required_if,
  confirmed
} from "vee-validate/dist/rules";

// register VeeValidate rules
extend("required", {
  ...required,
  message: (_, values) => {
    return values._field_ + " field is required";
  }
});
extend("email", {
  ...email,
  message: "Should be a valid email"
});
extend("alpha_num", alpha_num);
extend("min_value", min_value);
extend("max_value", max_value);
extend("min", {
  ...min,
  message: (_, values) => {
    return values._field_ + " field should have minimum " + values.length + " characters including spaces";
  }
});
extend("max", {
  ...max,
  message: (_, values) => {
    return values._field_ + " field should have maximum " + values.length + " characters including spaces";
  }
});
extend("length", length);
extend("integer", integer);
extend("regex", regex);
extend("required_if", required_if);
extend("confirmed", confirmed);
